import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import ThemeDecor from '../../img/decor/theme_decor.svg';
import ЕhemeArrow from '../../img/decor/theme_arrow.svg';

const EventThemesBase = ({ themesData }) => {

    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    return (
        <section className="mb-[60px] lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div>
                    <p className="text-[#010b13] font-medium mb-8 uppercase relative z-10">ПРО ЩО ПОГОВОРИМО</p>
                    <h2 className="text-[30px] uppercase font-bold relative z-10 xl:text-[55px] mb-8 lg:mb-12">{theme_title}</h2>

                    {theme_list.map((theme, index) => (
                        <div className="pb-5 mb-5 relative md:pb-11 md:mb-11 lg:flex lg:justify-between lg:gap-10" key={index}>

                            <div className="flex items-start gap-4 mb-5 lg:gap-10">
                                <img src={ЕhemeArrow} className="w-11 md:w-16"/>
                                <h3 className="font-bold uppercase text-[#010b13] leading-[1.3] md:text-[25px] lg:max-w-[430px]">{theme.title}</h3>
                            </div>

                            <p className="text-[#0b131c] leading-tight font-normal lg:w-[60%] lg:max-w-[600px]">{theme.desc}</p>

                            <img src={ThemeDecor} className="absolute bottom-0 w-full"/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default EventThemesBase;